import '../layouts/ansysoft.css';
import React, { useState } from 'react'
import logoBig from '../assets/logo-big.webp'
import { Link } from 'react-router-dom';
import { userLogin } from '../api/api';

const Signin = () => {

    const [loginData, setLoginData] = useState({
        user_name: "", password: "",
    });

    const handleChange = (e) => {
        const { value, name } = e.target;

        setLoginData((prev) => ({ ...prev, [name]: value }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = JSON.stringify(loginData);
        const response = await userLogin(data);

        console.log(response);
    }

    return (
        <>
            <div className="w-100 login-bg">
                <div className="login-bg-1">
                    <Link to="/app/home" className="logo-wrap"><img src={logoBig} alt="Prometa" className="logo" /></Link>
                    <h2 className="tagline mt-2 mt-md-0">Join the Entrepreneurial Revolution</h2>
                    <form className="login mt-5" onSubmit={handleSubmit}>

                        <input type="text" className="form-control login-field" id="user_name" placeholder="User Name"
                            value={loginData.user_name} name="user_name" required
                            onChange={handleChange}
                        />
                        <div className="form-control login-field d-flex align-items-center mt-4">
                            <input type="password" className="form-control login-field eye-field" id="password" placeholder="Password"
                                value={loginData.password} name="password" required
                                onChange={handleChange}
                            />
                            <i className="eye-icon fa-solid fa-eye-slash" show-hide-password for="password"></i>
                        </div>

                        <div className="forgot-password-wrap my-3">
                            {/* <input className="form-check-input ms-1" type="checkbox" id="rememberme" name="rememberme" />
                    <label className="form-check-label" for="rememberme">
                        Remember Me
                    </label>
                    <Link to="/forgotpassword" className="forgot-password">Forgot Password?</Link> */}
                        </div>

                        <button className="btn w-100 sign-in-btn" id="sign-in-btn" type="submit"
                        >Sign in</button>

                        <div className="signup-text mt-4">Didn't participate yet? <Link to="/signup">Sign Up</Link></div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default Signin